import { Form } from "formik";
import React from "react";
import { withRouter } from "react-router-dom";
import * as yup from "yup";

import Button from "../../../UI/Button";
import { CustomForm } from "../../../../component-library/CustomForm";
import FormikInput from "../../../UI/FormikInput";
import images from "../../../../utils/images";
import { yup_password_factory } from "../../../../utils/yupSchemaUtils";

const SetPassword = (props) => {
  const { setPassword, setSectionToShow } = props;

  const submitHandler = (formData) => {
    setPassword(formData.password);
    setSectionToShow("member_agreement");
  };

  const renderForm = (formikProps) => {
    const formikInputProps = {
      errors: formikProps.errors,
      inputClasses: "Input--sm",
      touched: formikProps.touched,
    };

    return (
      <Form>
        <div className="mx-auto px-0 mb-3">
          <div className="px-0 row pb-5">
            <div className="col-12">
              <FormikInput
                {...formikInputProps}
                formEl={{
                  elementConfig: {
                    label: "Create Password",
                    placeholder: "Password",
                    type: "password",
                  },
                  elementType: "input",
                  name: "password",
                }}
              />
            </div>

            <div className="col-12">
              <FormikInput
                {...formikInputProps}
                formEl={{
                  elementConfig: {
                    label: "Confirm Password",
                    placeholder: "Re-enter Password",
                    type: "password",
                  },
                  elementType: "input",
                  name: "password_validation",
                }}
              />
            </div>
          </div>
        </div>

        <div className="d-flex tw:justify-center">
          <Button className="Btn Btn--pri workflow-btn-lg" type="submit">
            Create & Continue
          </Button>
        </div>
      </Form>
    );
  };

  return (
    <>
      <div className="fs-22 txt-pri mb-5 text-center tw:font-bold">
        Welcome back! Please create your password
      </div>
      <div className="text-center my-5">
        <img alt="Create Password" src={images("./common/workflow/create-password.png")} />
      </div>
      <div className="workflow-container-sm">
        <CustomForm
          initialValues={{
            password: "",
            password_validation: "",
          }}
          onSubmit={submitHandler}
          render={renderForm}
          validationSchema={accountSetupValidation}
        />
      </div>
    </>
  );
};

export default withRouter(SetPassword);

const accountSetupValidation = yup.object().shape({
  password: yup_password_factory(),
  password_validation: yup
    .string()
    .required("Password Validation is required")
    .test("password-match", "Password does not match, please check spelling", function (value) {
      if (!value) {
        return false;
      }

      return this.parent.password === value;
    }),
});
